import { PaginationWrapper, PaginationButton } from "../CustomTableStyles";
import Colors from "../../../themes/Colors";

const Pagination = ({
  totalPages,
  currentPage,
  handlePageChange,
  paginationColor,
  font,
}) => {
  if (totalPages <= 1) return null;

  return (
    <PaginationWrapper font={font}>
      {Array.from(Array(totalPages).keys()).map((pageNumber) => (
        <PaginationButton
          key={pageNumber}
          active={pageNumber + 1 === currentPage}
          onClick={() => handlePageChange(pageNumber + 1)}
          paginationColor={paginationColor || Colors.primaryPrimera}
          font={font}
        >
          {pageNumber + 1}
        </PaginationButton>
      ))}
    </PaginationWrapper>
  );
};

export default Pagination;

